import { observer } from 'mobx-react-lite';
import { doBetStore } from '../../../../store';

export const CurrentAutoCashOutValue = observer(({ gameTypeId }) => {
  const { currentAutoCashOutOdd } = doBetStore.doBetSectionsData[gameTypeId];
  return (
    !!currentAutoCashOutOdd && (
      <div className='p-game-col-coef-wrp'>
        <span className='p-game-col-coef-icon'>
          <i className='bc-i-refresh' />
        </span>
        <span className='p-game-col-coef'> x{currentAutoCashOutOdd}</span>
      </div>
    )
  );
});
